import type { ComandoMia } from './catalogoComandosMia';
import styles from './AssistenteWidget.module.css';

type Props = {
  lista: ComandoMia[];
  atual: number;
  onEscolher: (comando: ComandoMia) => void;
};

export function ListaComandosMia({ lista, atual, onEscolher }: Props) {
  if (lista.length === 0) return null;
  return (
    <ul className={styles.comandos} role="listbox" aria-label="Comandos">
      {lista.map((comando, i) => (
        <li key={comando.comando} role="option" aria-selected={i === atual}>
          <button
            type="button"
            className={`${styles.comando} ${i === atual ? styles.comandoAtual : ''}`}
            // mousedown: escolhe antes do campo perder o foco.
            onMouseDown={(event) => {
              event.preventDefault();
              onEscolher(comando);
            }}
          >
            <strong>{comando.comando}</strong>
            <span>{comando.descricao}</span>
          </button>
        </li>
      ))}
    </ul>
  );
}
